import { useTranslate } from 'react-admin';

export const useApiIdentitiesT = (name = 'fields') => {
  const translate = useTranslate();
  const t = (key: string, variant = 0): string =>
    translate(['resources', 'apiIdentities', name, key].filter(Boolean).join('.'), variant);
  return t;
};
